import React, { useEffect, useMemo, useState } from 'react';
import { AttributeDetailRenderer, Attributes, DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
export default class StaticImageDetailRenderer extends AttributeDetailRenderer {
  getValueComponent(value, valueStyle, object) {
    const attr = Attributes.getAttribute(this.name, object.type);
    const val = attr.get(object?.data);
    if (val?.value?.[0] instanceof File) {
      return /*#__PURE__*/React.createElement("img", {
        src: URL.createObjectURL(val.value[0]),
        alt: val.value[0].name,
        style: {
          objectFit: 'contain',
          height: 100,
          width: 100
        }
      });
    }
    if (val && attr?.blueprint?.updatePath) {
      return /*#__PURE__*/React.createElement(ImageLoader, {
        value: val,
        attribute: attr,
        object: object,
        path: attr?.blueprint?.updatePath.slice(5)
      });
    }
    return /*#__PURE__*/React.createElement("div", null, "-");
  }
}
function ImageLoader({
  object,
  attribute,
  path,
  value
}) {
  const [src, setSrc] = useState();
  const [loading, setLoading] = useState(false);
  const delegate = useMemo(() => {
    return DataSources.getDelegate(object);
  }, [object]);
  useEffect(() => {
    const rsrc = delegate.resource(`resourceImage/${path}`).getRsrc(GlobalState.get());
    if (rsrc) {
      const url = new URL(rsrc.data.url);
      const expires = url.searchParams.get('Expires');
      const expiresDate = new Date(parseInt(expires) * 1000);
      if (expiresDate > new Date()) {
        if (rsrc.data.url !== src) {
          setSrc(rsrc.data.url);
        }
        return;
      }
    }
    setLoading(true);
    GlobalState.dispatch(delegate.resource(`resourceImage/${path}`).get()).then(res => {
      setSrc(res.data.url);
      setLoading(false);
      return res;
    });
  }, [value, path, src, delegate]);
  if (!delegate || !src) {
    return /*#__PURE__*/React.createElement("div", null, "-");
  }
  return /*#__PURE__*/React.createElement("img", {
    style: {
      width: 100,
      height: 100,
      objectFit: 'contain'
    },
    src: src,
    alt: src
  });
}